// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingChatClientes_BulkLookupInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/messaging_chat_clientes/bulk_lookup
 *
 * Bulk lookup for multiple identifiers.
 * Supports both old format { phones: [...] } and new format { identifiers: [...], identifier_type: "..." }.
 */
import { registerContract } from './validate'

export interface MessagingChatClientes_BulkLookupInput {
identifiers?: string[]
identifier_type?: string
phones?: string[]
}

registerContract('MessagingChatClientes_BulkLookupInput', {
  identifiers:     { type: 'array',   required: false },
  identifier_type: { type: 'string',  required: false },
  phones:          { type: 'array',   required: false },
})
